module.exports = __webpack_public_path__ + "media/media/values/theresa-girard-641e8732184f1deeff60eae80c2c9125.jpg";